export default __webpack_public_path__ + "static/media/sd-plus-icon.5293306a.png";